import { createAsyncThunk } from '@reduxjs/toolkit';

import { LoansService } from 'api';
import { DownloadLoanAgreementProps } from 'models/api';

import { downloadDocumentsWithAsyncPayloadCreator } from 'utils/downloadDocuments';

export const getPrimaryMarketItemAgreement = createAsyncThunk(
	'primaryMarket/getPrimaryMarketItemAgreement',
	(data: DownloadLoanAgreementProps, { rejectWithValue }) =>
		downloadDocumentsWithAsyncPayloadCreator(
			data,
			rejectWithValue,
			`Loan agreement #${data.id}.pdf`,
			LoansService.getAgreement,
		),
);
